import { deserializeActionData, type SerializedActionPayload, serializeActionData } from '@/lib/actions/serialization';
import type { AuthSession } from '@/types/auth';

export type SerializedAuthSession = SerializedActionPayload;
export type AuthSessionInput = AuthSession | SerializedAuthSession | null | undefined;

export function serializeAuthSession(
  session: AuthSession | null | undefined
): SerializedAuthSession | null | undefined {
  if (session === undefined) {
    return undefined;
  }
  if (session === null) {
    return null;
  }
  return serializeActionData(session);
}

export function deserializeAuthSession(session: AuthSessionInput): AuthSession | null | undefined {
  if (session === undefined || session === null) {
    return session;
  }
  return deserializeActionData<AuthSession>(session);
}
